import * as types from '../constants/ActionTypes'

import moment from 'moment'

//holiday
export const reducerRoumuSetWorkHolidayDates = (workHolidayDates) => ({
  type: types.REDUCER_ROUMU_SET_WORK_HOLIDAY_DATES,
  payload: {
    workHolidayDates: workHolidayDates
  }
})

export const reducerRoumuSetHolidayDates = (holidayDates) => ({
  type: types.REDUCER_ROUMU_SET_HOLIDAY_DATES,
  payload: {
    holidayDates: holidayDates
  }
})

export const reducerRoumuSubHolidayFormOpen = (subHolidayId, subHolidayDate, workHolidayId, workHolidayDate, workHolidayMode) => ({
  type: types.REDUCER_ROUMU_SUB_HOLIDAY_FORM_OPEN,
  payload: {
    subHolidayId: subHolidayId,
    subHolidayDate: subHolidayDate,
    workHolidayId: workHolidayId,
    workHolidayDate: workHolidayDate,
    workHolidayMode: workHolidayMode,
    subHolidayFormOpen: true,
  }
})

export const reducerRoumuSubHolidayFormClose = () => ({
  type: types.REDUCER_ROUMU_SUB_HOLIDAY_FORM_CLOSE,
  payload: {
    subHolidayFormOpen: false,
  }
})

export const userRoumuRegistSubHoliday = (form) => ({
  type: types.USER_ROUMU_REGIST_SUB_HOLIDAY,
  payload: {
    form: form
  }
})

//-----

export const userLogin = (form) => ({
  type: types.USER_LOGIN,
  payload: {
    form: form
  }
})

export const userLogout = () => ({
  type: types.USER_LOGOUT,
  payload: {
  }
})

export const reducerSetAuth = (user, loginState) => ({
  type: types.REDUCER_SET_AUTH,
  payload: {
    loginState: loginState,
    user: user
  }
})

export const systemFetchLoginState = (token) => ({
  type: types.SYSTEM_FETCH_LOGIN_STATE,
  payload: {
  }
})




export const reducerRoumuUpdateStore = (payload) => ({
  type: types.REDUCER_ROUMU_UPDATE_STORE,
  payload: payload
})

//============================================

export const userRoumuFormOpen = (event, kenmeiCodes) => ({
  type: types.USER_ROUMU_FORM_OPEN,
  payload: {
    event: event,
    kenmeiCodes: kenmeiCodes
  }
})

export const reducerRoumuFormOpen = (formData, currentKenmei) => ({
  type: types.REDUCER_ROUMU_FORM_OPEN,
  payload: {
    formData: formData,
    currentKenmei: currentKenmei,
    formOpen: true,
  }
})

export const userRoumuFormClose = () => ({
  type: types.USER_ROUMU_FORM_CLOSE,
  payload: {
  }
})

export const reducerRoumuFormClose = () => ({
  type: types.REDUCER_ROUMU_FORM_CLOSE,
  payload: {
    formData: null,
    formOpen: false
  }
})

export const reducerRoumuFormNext = (formData) => ({
  type: types.REDUCER_ROUMU_FORM_NEXT,
  payload: {
    formData
  }
})

export const userRoumuRegistEvent = (formData, next, yosanCosts) => ({
  type: types.USER_ROUMU_REGIST_EVENT,
  payload: {
    formData: formData,
    next: next,
    yosanCosts: yosanCosts,
  }
})

export const reducerRoumuSetCurrentKenmei = (currentKenmei) => ({
  type: types.REDUCER_ROUMU_SET_CURRENT_KENMEI,
  payload:{
    currentKenmei: currentKenmei
  }
})

export const systemRoumuInit = (userId, start, end) => ({
  type: types.SYSTEM_ROUMU_INIT,
  payload: {
    userId: userId,
    start: start,
    end: end
  }
})

export const systemRoumuGetEvents = (userId, start, end) => ({
  type: types.SYSTEM_ROUMU_GET_EVENTS,
  payload: {
    userId: userId,
    start: start,
    end: end
  }
})

export const reducerRoumuSetEvents = (events) => ({
  type: types.REDUCER_ROUMU_SET_EVENTS,
  payload: {
    events: events
  }
})

export const reducerRoumuSetSelectData = (kenmeiCodes, works) => ({
  type: types.REDUCER_ROUMU_SET_SELECT_DATA,
  payload: {
    kenmeiCodes: kenmeiCodes,
    works: works,
  }
})


export const reducerRoumuRemoveEvents = (events) => ({
  type: types.REDUCER_ROUMU_REMOVE_EVENTS,
  payload: {
    removeEvents: events,
  }
})

export const userRoumuApproval = (userId, roumuId, date, reply=false) => ({
  type: types.USER_ROUMU_APPROVAL,
  payload: {
    userId: userId,
    roumuId: roumuId,
    date: date,
    reply: reply
  }
})

export const reducerRoumuApprovalDialogOpen = (date) => ({
  type: types.REDUCER_ROUMU_APPROVAL_DIALOG_OPEN,
  payload: {
    approval: {
      date: date,
      open: true
    }
  }
})

export const reducerRoumuAlertDialogOpen = () => ({
  type: types.REDUCER_ROUMU_ALERT_DIALOG_OPEN,
  payload: {
    alertOpen: true
  }
})

export const reducerRoumuAlertDialogClose = (date) => ({
  type: types.REDUCER_ROUMU_ALERT_DIALOG_CLOSE,
  payload: {
    alertOpen: false
  }
})

export const systemRoumuGetYosanCosts = (id, kenmeiCode, costId) => ({
  type: types.SYSTEM_ROUMU_GET_YOSAN_COSTS,
  payload: {
    id: id,
    kenmeiCode: kenmeiCode,
    costId: costId
  }
})

export const systemRoumuGetWorkHoliday = (userId) => ({
  type: types.SYSTEM_ROUMU_GET_WORK_HOLIDAY,
  payload: {
    userId: userId
  }
})

export const reducerRoumuSetYosanCosts = (id, yosanCosts, disable) => ({
  type: types.REDUCER_ROUMU_SET_YOSAN_COSTS,
  payload: {
    id: id,
    yosanCosts: yosanCosts,
    disable: disable
  }
})

export const reducerRoumuSetWorkHoliday = (workHoliday) => ({
  type: types.REDUCER_ROUMU_SET_WORK_HOLIDAY,
  payload: {
    workHoliday: workHoliday
  }
})

export const reducerRoumuApprovalDialogClose = () => ({
  type: types.REDUCER_ROUMU_APPROVAL_DIALOG_CLOSE,
  payload: {
    approval: {
      date: '',
      open: false
    }
  }
})

//============================================

export const reducerAppLoading = (load) => ({
  type: types.REDUCER_APP_LOADING,
  payload: {
    load: load,
  }
})

//============================================

export const XXX = () => ({
  type: XXX,
  payload: {
  }
})

export const xxxFormSubmit = (values) => ({
  type: 'USER_FORM_SUBMIT',
  payload: {
    values: values
  }
})


//master
export const systemMasterInit = (masterType, form, page) => ({
  type: types.SYSTEM_MASTER_INIT,
  payload: {
    masterType: masterType,
    form: form,
    page: page,
  }
})

export const reducerMasterInit = (masterType) => ({
  type: types.REDUCER_MASTER_INIT,
  payload: {
    masterType: masterType
  }
})

export const userMasterSearch = (masterType, page, tmpForm) => ({
  type: types.USER_MASTER_SEARCH,
  payload: {
    masterType: masterType,
    page: page,
    tmpForm: tmpForm,
  }
})

export const reducerMasterSetClickKind = (masterType, clickKind) => ({
  type: types.USER_MASTER_SEARCH,
  payload: {
    masterType: masterType,
    clickKind: clickKind,
  }
})

export const reducerMasterSetList = (masterType, data, form, page) => ({
  type: types.REDUCER_MASTER_SET_LIST,
  payload: {
    masterType: masterType,
    list: data.list,
    count: data.count,
    page: page,
    form: form
  }
})

export const userMasterGetList = (masterType, page, tmpForm) => ({
  type: types.USER_MASTER_GET_LIST,
  payload: {
    masterType: masterType,
    page: page,
    tmpForm: tmpForm
  }
})


export const userMasterFormRegist = (masterType, id, form, page, tmpForm) => ({
  type: types.USER_MASTER_FORM_REGIST,
  payload: {
    masterType: masterType,
    id: id,
    form: form,
    page: page,
    tmpForm: tmpForm
  }
})

export const userMasterFormEdit = (masterType, id) => ({
  type: types.USER_MASTER_FORM_EDIT,
  payload: {
    masterType: masterType,
    id: id
  }
})


export const userMasterFormDelete = (masterType, id, page, tmpForm) => ({
  type: types.USER_MASTER_FORM_DELETE,
  payload: {
    masterType: masterType,
    id: id,
    page: page,
    tmpForm: tmpForm
  }
})


export const reducerMasterSetForm = (masterType, form) => ({
  type: types.REDUCER_MASTER_SET_FORM,
  payload: {
    masterType: masterType,
    form: form
  }
})


export const reducerMasterFormReset = (masterType) => ({
  type: types.REDUCER_MASTER_FORM_RESET,
  payload: {
    masterType: masterType
  }
})


export const reducerMasterSetSelectData = (masterType, selectData) => ({
  type: types.REDUCER_MASTER_SET_SELECT_DATA,
  payload: {
    selectData: selectData,
    masterType: masterType
  }
})


//-----------------
// yosan
//-----------------
export const reducerYosanTest = () => ({
  type: types.REDUCER_YOSAN_TEST,
  payload: {
      testLoading: false
  }
})

export const systemYosanInit = (id) => ({
  type: types.SYSTEM_YOSAN_INIT,
  payload: {
    id: id
  }
})

export const systemYosanHistoryInit = (id, yearMonth) => ({
    type: types.SYSTEM_YOSAN_HISTORY_INIT,
    payload: {
        id: id,
        yearMonth: yearMonth
    }
})

export const reducerYosanInit = (form, selectData, kenmeiNames) => ({
  type: types.REDUCER_YOSAN_INIT,
  payload: {
    transition: false,
    form: form,
    selectData: selectData,
    kenmeiNames: kenmeiNames,
  }
})

export const reducerYosanHistoryInit = (form, selectData, kenmeiNames) => ({
    type: types.REDUCER_YOSAN_HISTORY_INIT,
    payload: {
        transition: false,
        form: form,
        selectData: selectData,
        kenmeiNames: kenmeiNames,
    }
})

export const userYosanHistoryCostOpens= (kind, month) => ({
    type: types.USER_YOSAN_HISTORY_COST_OPEN,
    payload: {
        kind, month
    }
})

export const userYosanFormRegist = (id, form, startDate, endDate) => ({
  type: types.USER_YOSAN_FORM_REGIST,
  payload: {
    id: id,
    form: form,
    startDate: startDate,
    endDate: endDate
  }
})

export const userYosanFormDelete = (id, form) => ({
    type: types.USER_YOSAN_FORM_DELETE,
    payload: {
        id: id,
        form: form
    }
})

export const reducerYosanSetTransition = (transition) => ({
  type: types.REDUCER_YOSAN_SET_TRANSITION,
  payload: {
    transition: transition,
  }
})

export const reducerYosanStateClear = () => ({
    type: types.REDUCER_YOSAN_STATE_CLEAR,
    payload: {
    }
})

export const reducerYosanSetKenmeiNames = (kenmeiNames) => ({
  type: types.REDUCER_YOSAN_SET_KENMEI_NAMES,
  payload: {
    kenmeiNames: kenmeiNames,
  }
})

//-------------------------
// yosanList
//-------------------------
export const systemYosanListInit = (page, form) => ({
  type: types.SYSTEM_YOSANLIST_INIT,
  payload: {
    page: page,
    form: form
  }
})

export const systemYosanHistoryListInit = (page, form) => ({
  type: types.SYSTEM_YOSANHISTORYLIST_INIT,
  payload: {
    page: page,
    form: form
  }
})

export const reducerYosanListInit = (data, page, form, selectData) => ({
  type: types.REDUCER_YOSANLIST_INIT,
  payload: {
    yearMonthList: data.yearMonthList,
    list: data.list,
    count: data.count,
    form: form,
    page: page,
    selectData: selectData,
    // list: list
  }
})

export const reducerYosanHistoryListInit = (data, page, form, selectData) => ({
    type: types.REDUCER_YOSANHISTORYLIST_INIT,
    payload: {
        yearMonthList: data.yearMonthList,
        list: data.list,
        count: data.count,
        form: form,
        page: page,
        selectData: selectData,
        // list: list
    }
})

export const userYosanListSearch = (page, form, report) => ({
  type: types.USER_YOSANLIST_SEARCH,
  payload: {
    page: page,
    form: form,
    report: report,
  }
})

export const userYosanHistoryListSearch = (page, form, report) => ({
    type: types.USER_YOSANHISTORYLIST_SEARCH,
    payload: {
        page: page,
        form: form,
        report: report,
    }
})

export const reducerYosanListSetSearchResult = (data, form, page) => ({
  type: types.REDUCER_YOSANLIST_SET_SEARCH_RESULT,
  payload: {
    list: data.list,
    count: data.count,
    form: form,
    page: page,
  }
})

export const reducerSummaryCsvResult = (data) => ({
  type: types.REDUCER_SUMMARYCSV_RESULT,
  payload: {
    summaryCsv: data,
    summaryCsvOpen: true,
  }
})

export const reducerSummaryCsvClose = () => ({
  type: types.REDUCER_SUMMARYCSV_CLOSE,
  payload: {
    summaryCsv: null,
    summaryCsvOpen: false,
  }
})

export const reducerYosanHistoryListSetSearchResult = (data, form, page) => ({
    type: types.REDUCER_YOSANHISTORYLIST_SET_SEARCH_RESULT,
    payload: {
        yearMonthList: data.yearMonthList,
        list: data.list,
        count: data.count,
        form: form,
        page: page,
    }
})

export const reducerYosanListFormClear = () => ({
  type: types.REDUCER_YOSANLIST_FORM_CLEAR,
  payload: {
    form: {
      rand: moment().unix()
    },
  }
})

export const reducerYosanHistoryListFormClear = () => ({
    type: types.REDUCER_YOSANHISTORYLIST_FORM_CLEAR,
    payload: {
        form: {
            rand: moment().unix()
        },
    }
})

export const userYosanListUpload = (file) => ({
    type: types.USER_YOSANLIST_UPLOAD,
    payload: {
        file: file
    }
})


export const reducerYosanListTest = (page, form) => ({
  type: types.REDUCER_YOSANLIST_INIT,
  payload: {
    page: page,
    form: form,
  }
})

//-----------------
// global
//-----------------
export const reducerSnackBar = (open, message, color) => ({
  type: types.REDUCER_SNACKBAR,
  payload: {
    snackbar: {
      open: open,
      message: message,
      color: color
    }
  }
})

export const reducerErrorMessage = (message) => ({
    type: types.REDUCER_ERROR_MESSAGE,
    payload: {
        errorMessage: message
    }
})


//-------------------
// V2
//-------------------

export const systemBizHolidayInit = () => ({
  type: types.SYSTEM_BIZ_HOLIDAY_INIT,
  payload: {
  }
})

export const reducerBizHolidayInit = (year, list) => ({
  type: types.REDUCER_BIZ_HOLIDAY_INIT,
  payload: {
    year, list
  }
})

export const reducerBizHolidayRemoveDate = (month, index, list) => ({
  type: types.REDUCER_BIZ_HOLIDAY_REMOVE_DATE,
  payload: {
    month, index, list
  }
})

export const userBizHolidayRegist = (form) => ({
  type: types.USER_BIZ_HOLIDAY_REGIST,
  payload: {
    form
  }
})

export const userBizHolidayChangeYear = (year) => ({
  type: types.USER_BIZ_HOLIDAY_CHANGE_YEAR,
  payload: {
    year
  }
})



export const systemSubHolidayInit = (userId) => ({
  type: types.SYSTEM_SUB_HOLIDAY_INIT,
  payload: {
    userId
  }
})

export const reducerSubHolidayInit = (list) => ({
  type: types.REDUCER_SUB_HOLIDAY_INIT,
  payload: {
    list
  }
})

export const userSubHolidayRegist = (userId, form) => ({
  type: types.USER_SUB_HOLIDAY_REGIST,
  payload: {
    userId,
    form
  }
})


export const userSystemControllSubHolidayClear = (form) => ({
  type: types.USER_SYSTEM_CONTROLL_SUB_HOLIDAY_CLEAR,
  payload: {
    form
  }
})

export const systemSystemControllRoumuInit = () => ({
  type: types.SYSTEM_SYSTEMCONTROLL_ROUMU_INIT,
  payload: {
  }
})

export const reducerSystemControllRoumuInit = (selectData) => ({
  type: types.REDUCER_SYSTEMCONTROLL_ROUMU_INIT,
  payload: {
    selectData: selectData
  }
})


export const reducerRoumuFormReset = () => ({
  type: types.REDUCER_ROUMU_FORM_RESET,
  payload: {}
})



// WEBPACK FOOTER //
// ./src/actions/index.js